import { Form, FormValueScope } from '@epages/react-components'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'

import { useTranslate } from '../../../../../utils/translate'
import Button from '../../../../formComponents/Button'
import ButtonRow from '../../../../formComponents/ButtonRow'
import CustomHtmlField from '../../../../formComponents/CustomHtmlField'

function normalize(data) {
  return data.update('html', (html) => (html ? html.trim() : ''))
}

export default function FreeHtmlSettingsForm({ data, onSave, onCancel, onDataChange, renderLayout }) {
  const t = useTranslate('interface', 'components.freeHtmlElementComponent.settingsModal')

  return (
    <Form name="pluginFreeHtmlSettings" value={data} onChange={onDataChange} onSubmit={onSave} normalize={normalize}>
      {renderLayout({
        title: data.get('html') ? t('title.onEdit') : t('title.onCreate'),
        body: (
          <scroll-shadow>
            <div className="dali-settingslayer-main-content">
              <FormValueScope name="html">
                <CustomHtmlField onChange={onDataChange} />
              </FormValueScope>
            </div>
          </scroll-shadow>
        ),
        footer: (
          <ButtonRow>
            <Button type="button" variant="cancel" onClick={onCancel}>
              {t('cancelButton.label')}
            </Button>
            <Button type="submit">{t('saveButton.label')}</Button>
          </ButtonRow>
        ),
      })}
    </Form>
  )
}

FreeHtmlSettingsForm.propTypes = {
  data: ImmutablePropTypes.map.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDataChange: PropTypes.func.isRequired,
  renderLayout: PropTypes.func.isRequired,
}
